const DISPLAY_ENTITY_TYPES = Object.freeze({
  Partner: 'Tech Company',
  Partners: 'Tech Companies',
  Company: 'Corporation',
  Companies: 'Corporations',
});

function displayEntityType(value) {
  const normalized = String(value || '').trim();
  return DISPLAY_ENTITY_TYPES[normalized] || normalized;
}

function displayEntityTaxonomyText(value) {
  return String(value || '').replace(
    /\b(Partners|Companies|Partner|Company)\b/g,
    entityType => DISPLAY_ENTITY_TYPES[entityType],
  );
}

module.exports = {
  DISPLAY_ENTITY_TYPES,
  displayEntityTaxonomyText,
  displayEntityType,
};
